import * as XLSX from 'xlsx';

export interface RecordExcelRow {
  name: string;
  dob: string;
  idNumber: string;
  telephone1: string;
  telephone2: string;
  telephone3: string;
  telephone4: string;
  telephone5: string;
  telephone6: string;
  telephone7: string;
  telephone8: string;
}

function sanitizeCell(value: string): string {
  return value && value.trim() ? value.trim() : 'N/A';
}

export function exportRecordsExcel(rows: RecordExcelRow[], filename: string): void {
  const headers = [
    'Name',
    'DOB',
    'ID Nr',
    'Telephone 1',
    'Telephone 2',
    'Telephone 3',
    'Telephone 4',
    'Telephone 5',
    'Telephone 6',
    'Telephone 7',
    'Telephone 8',
  ];
  const baseNameWidth = 18;
  const baseIdWidth = 15;
  const basePhoneWidth = 15;
  const dataRows = rows.length
    ? rows.map((row) => ({
        Name: sanitizeCell(row.name),
        DOB: sanitizeCell(row.dob),
        'ID Nr': sanitizeCell(row.idNumber),
        'Telephone 1': sanitizeCell(row.telephone1),
        'Telephone 2': sanitizeCell(row.telephone2),
        'Telephone 3': sanitizeCell(row.telephone3),
        'Telephone 4': sanitizeCell(row.telephone4),
        'Telephone 5': sanitizeCell(row.telephone5),
        'Telephone 6': sanitizeCell(row.telephone6),
        'Telephone 7': sanitizeCell(row.telephone7),
        'Telephone 8': sanitizeCell(row.telephone8),
      }))
    : [
        {
          Name: 'N/A',
          DOB: 'N/A',
          'ID Nr': 'N/A',
          'Telephone 1': 'N/A',
          'Telephone 2': 'N/A',
          'Telephone 3': 'N/A',
          'Telephone 4': 'N/A',
          'Telephone 5': 'N/A',
          'Telephone 6': 'N/A',
          'Telephone 7': 'N/A',
          'Telephone 8': 'N/A',
        },
      ];

  const sheet = XLSX.utils.json_to_sheet(dataRows, { header: headers });
  sheet['!cols'] = [
    { wch: Math.round(baseNameWidth * 2) },      // Name: 2x
    { wch: 12 },                                  // DOB: unchanged
    { wch: Math.round(baseIdWidth * 1.33) },      // ID Nr: +33%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 1: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 2: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 3: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 4: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 5: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 6: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 7: +20%
    { wch: Math.round(basePhoneWidth * 1.2) },    // Telephone 8: +20%
  ];
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, sheet, 'Records');
  XLSX.writeFile(workbook, filename, { compression: true });
}
